// extracted by mini-css-extract-plugin
export default {"appIcon":"AppIcon_appIcon__KV3xj"};